import { customInstance } from '@ping/api/custom-instance';

export const KYB_BUSINESS_REVIEW_DOCUMENTS_PATH = '/frontoffice/api/kyb/business/review/documents';

export const KYB_BUSINESS_REVIEW_SUBMIT_PATH = '/frontoffice/api/kyb/business/review/submit';

export const KYB_REVIEW_DOCUMENT_TYPE = 'ProofOfFunds';

export const MAX_REVIEW_DOCUMENT_BYTES = 5 * 1024 * 1024;

export const uploadKybReviewDocument = (file: File) => {
  const body = new FormData();
  body.append('documents', file, file.name);

  return customInstance({
    url: KYB_BUSINESS_REVIEW_DOCUMENTS_PATH,
    method: 'POST',
    params: { documentType: KYB_REVIEW_DOCUMENT_TYPE },
    data: body,
  });
};

export const submitKybReview = () =>
  customInstance({
    url: KYB_BUSINESS_REVIEW_SUBMIT_PATH,
    method: 'POST',
  });

export const uploadFailureMessage = (error: unknown): string => {
  const status = (error as { response?: { status?: number } } | null)?.response?.status;
  if (status === 413) {
    return 'This file is larger than the allowed size.';
  }

  return 'The document could not be uploaded.';
};
